import { useEffect, useState } from "react";
import { useAuth } from "../Services/AuthContext";
import { useNavigate } from "react-router-dom";
import { Eye, EyeOff } from "lucide-react";
import { ServiceData } from "../Services/Service";
import { toast } from "react-toastify";

interface LoginProps {
    nom: string;
    password: string;
}

const Login=()=>{
    const [formdata,setFormdata] = useState<LoginProps>({
        nom: "",
        password: ""
    });
    const[token,setToken] = useState<string|null>(null);
    const [showPassword,setShowPassword]=useState<boolean>(false);
    const [isLoading,setIsLoading]=useState<boolean>(false);

    const navigate=useNavigate();

    const{login,user}=useAuth();
    
    useEffect(() => {
        if (user) {
        navigate("/", { replace: true });
        }
    }, [user, navigate]);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setFormdata({
            ...formdata,
            [e.target.name]: e.target.value
        }); 
    }
    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault(); 
        try {
            setIsLoading(true);
            const response=await ServiceData("/api/login","POST",formdata);
            setToken(response.token);
            window.localStorage.setItem("token", response.token);
            window.localStorage.setItem("refresh_token", response.refresh_token);
            login({
                nom:formdata.nom,
                roles:response.roles
            })
            toast.success("Connexion réussie.");
            setIsLoading(false);
            navigate("/");
        }catch(err:any){
            setIsLoading(false);
            toast.error("Erreur de la connexion.");
        }
    };
    
 return(
    <div className="container mt-5">
    <div className="p-4 mx-auto bg-white rounded shadow mb-5" style={{ maxWidth: "800px" }}>
        <div className="row align-items-center">
        
        <div className="col-md-6 text-center bg-light p-4 rounded-start">
            <img 
            src="/bg-login.png" 
            alt="imagelogin" 
            className="img-fluid rounded" 
            />
        </div>

        <div className="col-md-6 p-4">
            <form onSubmit={handleSubmit} className="d-flex flex-column gap-3">
            <h3 className="text-center mb-3">Connexion</h3>
                {isLoading && (
                    <div className="text-center">
                    <img src="/chargement.gif" alt="Chargement..." style={{ width: '40px', height: '40px' }} />
                    </div>
                )}            
            <input 
                type="text" 
                name="nom" 
                placeholder="Nom d'utilisateur" 
                value={formdata.nom} 
                onChange={handleChange} 
                required 
                className="form-control"
            />

            <div className="input-group">
            <input
                type={showPassword ? 'text' : 'password'}
                name="password"
                placeholder="Mot de passe"
                value={formdata.password}
                onChange={handleChange}
                required
                className="form-control"
                />
                <span className="input-group-text" style={{ cursor: 'pointer' }} onClick={() => setShowPassword(!showPassword)}>
                {showPassword ? <EyeOff size={18}/> : <Eye size={18}/>}
                </span>
            </div>

            <button type="submit" className="btn btn-primary w-100">Se connecter</button>
            </form>
        </div>
        
        </div>
    </div>
    </div>

 )
}
export default Login;